import { render, staticRenderFns } from "./PortalUserActivity.vue?vue&type=template&id=94007078&scoped=true&"
import script from "./PortalUserActivity.vue?vue&type=script&lang=js&"
export * from "./PortalUserActivity.vue?vue&type=script&lang=js&"
import style0 from "./PortalUserActivity.vue?vue&type=style&index=0&id=94007078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94007078",
  null
  
)

export default component.exports